var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitAbsencesLate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 14.375H15.25C14.7668 14.375 14.375 14.7668 14.375 15.25V32.75C14.375 33.2332 14.7668 33.625 15.25 33.625H32.75C33.2332 33.625 33.625 33.2332 33.625 32.75V15.25C33.625 14.7668 33.2332 14.375 32.75 14.375Z",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 12.625V16.125",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.625V16.125",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 19.625H33.625",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0625 24H23.125L21.375 26.1875C21.663 26.187 21.9467 26.2576 22.2009 26.393C22.455 26.5284 22.6719 26.7245 22.8321 26.9638C22.9924 27.2031 23.0911 27.4783 23.1195 27.7649C23.1479 28.0515 23.1051 28.3407 22.995 28.6068C22.8848 28.8729 22.7107 29.1077 22.488 29.2904C22.2654 29.4731 22.0011 29.598 21.7186 29.654C21.4361 29.7101 21.1441 29.6955 20.8686 29.6117C20.593 29.5279 20.3425 29.3773 20.1391 29.1734",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 25.3125L27.5 24V29.6875",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 16,
    r: 5,
    fill: "#DF2C0F",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitAbsencesLate);
export default __webpack_public_path__ + "static/media/VisitAbsencesLate.59133e7143411f45a1bec0f846570fd8.svg";
export { ForwardRef as ReactComponent };